/**
 * Bilingual copy for the Blog article page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  layoutTitleSuffix: 'AKAS Blogs',
  fallbackDescription: 'Learn more about AKAS cloud-based business ERP solutions.',
  loading: 'Loading article...',
  notFoundTitle: "This page isn't available",
  notFoundBody:
    "The link may be broken, or the page may have been removed. Check to see if the link you're trying to open is correct.",
  backToBlog: 'Back to blog',
  backToBlogs: 'Back to blogs',
  byAuthor: 'By',
  readMore: 'Read more articles',
};

export type Copy = typeof en;

export const km: Copy = {
  layoutTitleSuffix: 'ប្លុក AKAS',
  fallbackDescription: 'ស្វែងយល់បន្ថែមអំពីដំណោះស្រាយគ្រប់គ្រងអាជីវកម្មលើពពករបស់ AKAS។',
  loading: 'កំពុងផ្ទុកអត្ថបទ...',
  notFoundTitle: 'ទំព័រនេះមិនមានទេ',
  notFoundBody:
    'តំណអាចខូច ឬទំព័រនេះអាចត្រូវបានដកចេញរួចហើយ។ សូមពិនិត្យមើលថាតំណដែលអ្នកកំពុងបើកនោះត្រឹមត្រូវឬអត់។',
  backToBlog: 'ត្រឡប់ទៅប្លុកវិញ',
  backToBlogs: 'ត្រឡប់ទៅបញ្ជីប្លុកវិញ',
  byAuthor: 'ដោយ',
  readMore: 'អានអត្ថបទបន្ថែមទៀត',
};
